/**
 * حفظ ملف على جهاز المستخدم — في المتصفّح وفي تطبيق سطح المكتب.
 *
 * `<a download>` مع blob: لا يفعل شيئاً داخل نافذة Tauri: WebView لا يملك مدير
 * تنزيلات، فتنقر «تصدير» ولا يحدث شيء بلا خطأ. في سطح المكتب نفتح نافذة «حفظ باسم»
 * ونكتب الملف بأنفسنا؛ في المتصفّح نبقي على التنزيل المعتاد.
 */
const isTauri = () => typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window

export async function saveFile(blob: Blob, filename: string): Promise<'saved' | 'cancelled'> {
  if (isTauri()) {
    const [{ save }, { writeFile }] = await Promise.all([
      import('@tauri-apps/plugin-dialog'),
      import('@tauri-apps/plugin-fs'),
    ])
    const ext = filename.split('.').pop() ?? ''
    const path = await save({
      defaultPath: filename,
      filters: ext ? [{ name: ext.toUpperCase(), extensions: [ext] }] : undefined,
    })
    if (!path) return 'cancelled'
    // المسار الذي اختاره المستخدم يُضاف تلقائياً إلى نطاق fs — لا حاجة لفتح $HOME كلّه
    await writeFile(path, new Uint8Array(await blob.arrayBuffer()))
    return 'saved'
  }

  const href = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = href
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  // الإبطال بعد دورة حدث: بعض المتصفّحات تبدأ التنزيل بعد إرجاع click()
  setTimeout(() => URL.revokeObjectURL(href), 1000)
  return 'saved'
}

/** جلب ملف محميّ بالرمز ثم حفظه — الرمز في الترويسة لا في الرابط، فلا يصلح رابط مباشر */
export async function fetchAndSave(url: string | URL, token: string, filename: string) {
  const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } })
  if (!res.ok) throw new Error('تعذّر تحضير الملف للتصدير')
  return saveFile(await res.blob(), filename)
}
